<template>
  <FormSelect
    :value="value"
    @input="updateValue"
    :optionsPromise="accountLocationPromise"
    :field="field"
    :placeholder="placeholder"
    :note="note"
  />
</template>



<script>
import _ from 'lodash'

export default {
  name: 'AccountLocationSelect',
  model: {
    event: 'update'
  },
  props: {
    value: [Number, String],
    field: String,
    placeholder: String,
    note: String,
    allowNone: Boolean,
    activeOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      accountLocationPromise: this.getAccountLocationPromise(),
    }
  },
  methods: {
    getAccountLocationPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.adminService.getAccountLocations()
        .then(response => {
          let accList = response.data

          if(this.activeOnly)
            accList = accList.filter(location => location.isActive)

          var accountOptions = accList.map((location, index) => {
            return { name: `${location.name} - ${location.formattedAddress}`, value: location.id, isDefault: index == 0 }
          })

          return resolve(_.concat(_.compact(this.allowNone ? [{ value: null, name: 'None' }] : null), accountOptions))
        })
        .catch(err => { return reject(err) })
      })
    },
    updateValue(value) {
      this.$emit('update', value)
    }

  }
}
</script>